import { useStore, useToast, types } from '@balm-ui';
import { isDev } from '@yiban-shared/config';

const $toast = useToast();

export default ({ getFormDataWithDefaultParams, switchFn, afterHandler }) =>
  async function setModelDataFn(detailViewData) {
    const $store = useStore();
    const action = detailViewData.action || {};
    const {
      model,
      modelAction,
      modelOptions,
      keyName,
      detailData,
      detailDataSource
    } = detailViewData;

    let hasPrimaryKey = false;
    let formPrimaryKeyData = {};

    if (Array.isArray(keyName)) {
      keyName.forEach((key) => {
        const id = detailDataSource[key] || detailData[key];
        id && (formPrimaryKeyData[key] = id);
      });
      if (Object.keys(formPrimaryKeyData).length === keyName.length) {
        hasPrimaryKey = true;
      }
    } else {
      const id = detailDataSource[keyName] || detailData[keyName];
      if (id) {
        hasPrimaryKey = true;
        formPrimaryKeyData[keyName] = id;
      }
    }

    let fn = hasPrimaryKey ? 'updateModel' : 'createModel';
    if (types.isFunction(switchFn)) {
      const newFn = switchFn({ action, model, modelAction });
      newFn && (fn = newFn);
    }

    const postData = getFormDataWithDefaultParams
      ? await getFormDataWithDefaultParams(
          'detail-view',
          Object.assign(formPrimaryKeyData, detailData),
          { actionType: 'set', ...detailViewData }
        )
      : Object.assign(formPrimaryKeyData, detailData);
    const postConfig =
      modelAction === 'delete'
        ? {}
        : modelOptions.requestOptions
        ? Object.assign({}, modelOptions.requestOptions, {
            apiAction: action.apiAction || modelAction
          })
        : { apiAction: action.apiAction || modelAction };

    isDev && console.info('setModelDataFn', fn, model, postData, postConfig);

    const result = await $store[`$${fn}`](model, postData, postConfig);

    $toast('操作成功');

    afterHandler &&
      afterHandler(Object.assign(formPrimaryKeyData, detailData), {
        actionType: 'set',
        responseData: result,
        ...detailViewData
      });

    return result;
  };
